__turbopack_context__.v({
  "splide__arrow": "ShowRowSplide-module-scss-module__24GNYG__splide__arrow",
  "splide__list": "ShowRowSplide-module-scss-module__24GNYG__splide__list",
  "splide__slide": "ShowRowSplide-module-scss-module__24GNYG__splide__slide",
});
